import { ReactNode } from 'react';

import classes from './createEditSchemaModal.module.css';

type LabelWithDescriptionProps = {
  title: string;
  description: ReactNode;
};

const LabelWithDescription = ({
  title,
  description,
}: LabelWithDescriptionProps) => (
  <div className={classes.labelWithDescription}>
    <div className={classes.labelTitle}>{title}</div>
    <div className={classes.labelDescription}>{description}</div>
  </div>
);

export default LabelWithDescription;
